<template>
    <div class="__l">
        <h1 class="title">Packages</h1>
        <div class="actions right text-right">
            <button class="btn-primary" type="button" @click="createGroup">Create Package</button>
        </div>
        <input type="text" v-model="search" class="form-field py-4 px-6" ref="searchbar"
               placeholder="Search for Packages" @keyup.enter="handleSearch">

        <div class="results-list">
            <div class="results-row">
                <div class="results-head" data-width="10%">ID</div>
                <div class="results-head" data-width="60%">Name</div>
                <div class="results-head" data-width="10%">Cost</div>
                <div class="results-head" data-width="20%">Cost (inc. Tax)</div>
                <div class="results-head" data-width="10%">Active</div>
            </div>
            <template v-if="results.data">
                <div class="results-row" v-for="(result, index) in results.data" :key="index"
                     @click="handleSelected(result)">
                    <div class="results-cell" data-width="10%">{{ result.id }}</div>
                    <div class="results-cell truncate" data-width="60%">{{ result.name }}</div>
                    <div class="results-cell" data-width="20%">£ {{ result.cost }}</div>
                    <div class="results-cell" data-width="20%">£ {{ Number(result.gross_cost).toFixed(2) }}</div>
                    <div class="results-cell" data-width="10%">{{ result.active ? 'Yes' : 'No' }}</div>
                </div>
                <pagination v-model="page" :records="results.total" :per-page="25" @paginate="loadData"></pagination>
            </template>
            <div class="results-row" v-if="!results.data">
                <div class="results-span text-center" data-width="100%">
                    <p>No results found</p>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import Pagination from 'v-pagination-3'

export default {
    name: 'Packages',
    data() {
        return {
            search: null,
            results: {},
            page: 1,
        }
    },
    components: {
        Pagination
    },
    mounted() {
        this.loadData()

        window.setTimeout(function () {
            this.$refs.searchbar.focus()
        }.bind(this), 100)

        this.setMetaTitle('Packages | JournoLink Control')
    },
    methods: {
        handleSearch() {
            this.loadData()
        },
        /**
         * Load the results from the data provider
         *
         * @return {void}
         */
        loadData() {
            axios.get(route('packages.list'), {
                params: {
                    term: this.search,
                    page: this.page,
                },
            })
                .then(response => {
                    this.results = response.data.results
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle the selection of a AccountGroup
         *
         * @param  {Object} record
         * @return {void}
         */
        handleSelected(record) {
            this.$router.push({name: 'packages.show', params: {id: record.id}})
        },
        /**
         * Create a new AccountGroup
         *
         * @return {void}
         */
        createGroup() {
            this.$router.push({name: 'packages.create'})
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (to && to.name === 'packages.list') {
            this.setMetaTitle('Packages | JournoLink Control')
            this.loadData()
        }

        if (to && to.params.newRecord) {
            window.setTimeout(() => {
                this.handleSelected(to.params.newRecord)
            }, 500)

            next()
        }

        next()
    },
}
</script>

<style lang="less" scoped>

</style>
